import { Record } from 'immutable';

export default class PaymentRowRecord extends Record({
  id: undefined,
  description: undefined,
  from: undefined,
  quantity: undefined,
  salaryCode: undefined,
  shortDescription: undefined,
  to: undefined,
  total: undefined,
  unitPrice: undefined,
}) {
}
